import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Col, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useLocation } from 'react-router-dom'

import { MARKETING } from '../../../../constants'
import { marketingAct } from '../../../../redux/actions'
import Step3Chatmail from './Step3Chatmail'
import Step3Facebook from './Step3Facebook'
import Step3WhatsApp from './Step3WhatsApp'
import Step3Sms from './Step3Sms'
import Step3Telegram from './Step3Telegram'
import Step3Wall from './Step3Wall'
import Step3Instagram from './Step3Instagram'
import Step3WhatsAppCloudApi from './Step3WhatsAppCloudApi'
import { getStaticImage } from 'utils/statics'

const Step3 = ({ getAllTemplates, getTemplateVariables, templates, variables, error }) => {
  const { pathname } = useLocation()
  const isChat = pathname === '/dashboard/conversations/templates'

  const { company } = templates
  const [isFetching, setIsFetching] = useState(true)

  const state = useSelector((state) => state.marketing.campaign)
  const { usersByChannel } = state

  const usersByChannelObj = usersByChannel.length
    ? usersByChannel.reduce((a, c) => {
      a[c.channel] = true
      return a
    }, {})
    : {
      chatmail: true,
      /*facebook: true,*/
      whatsapp: true,
      whatsapp_whatsapp: true,
      sms: true,
      telegram: true, /*chatweb: true,*/
      android: true,
      ios: true/*, instagram: true*/
    }

  // const defaultStepOption = Object.keys(usersByChannelObj).length ? Object.keys(usersByChannelObj)[0] : MARKETING.channels.facebook
  const [stepOption, setStepOption] = useState(
    usersByChannelObj.chatmail
      ? MARKETING.channels.chatmail
      : usersByChannelObj.whatsapp
        ? MARKETING.channels.whatsapp
        : usersByChannelObj.sms
          ? MARKETING.channels.sms
          : usersByChannelObj.telegram
            ? MARKETING.channels.telegram
            : usersByChannelObj.android
              ? MARKETING.channels.android
              : usersByChannelObj.ios
                ? MARKETING.channels.ios
                : usersByChannelObj.whatsapp_whatsapp
                  ? MARKETING.channels.whatsapp_whatsapp
                  : ''

  )

  const channelOptions =
    stepOption !== ''
      ? templates[stepOption].map((t) => ({
        value: t._id,
        label: t.name,
        data: t,
      }))
      : []

  const channelTemplates = templates[stepOption]

  useEffect(() => {
    Promise.all([getTemplateVariables(), getAllTemplates(isChat, { status: 'APPROVED' })])
      .catch(console.error)
      .finally(() => setIsFetching(false))
  }, [getAllTemplates, getTemplateVariables, isChat])

  const getCurrentFormStepOption = (option) => {
    const options = {
      chatmail: (
        <Step3Chatmail
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
        />
      ),
      facebook: (
        <Step3Facebook
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
          error={error}
        />
      ),
      instagram: (
        <Step3Instagram
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
          error={error}
        />
      ),
      whatsapp: (
        <Step3WhatsApp
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
        />
      ),
      sms: (
        <Step3Sms
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
        />
      ),
      telegram: (
        <Step3Telegram
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
        />
      ),
      chatweb: (
        <Step3Wall
          key={stepOption}
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
          name='ChatWeb'
        />
      ),
      android: (
        <Step3Wall
          key={stepOption}
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
          name='Android'
        />
      ),
      ios: (
        <Step3Wall
          key={stepOption}
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
          name='iOS'
        />
      ),
      whatsapp_whatsapp: (
        <Step3WhatsAppCloudApi
          currentTemplate={stepOption}
          company={company}
          variables={variables}
          options={channelOptions}
          templates={channelTemplates}
          isFetching={isFetching}
        />
      ),
    }

    return options[option]
  }

  return (
    <>
      <h1>{I18n.t('dashboard_messages')}</h1>
      <p className='summary'></p>

      <Row className='my-3'>
        <Col sm={12} xs={3} xl={3}>
          <ul className='message-editor'>
            {usersByChannelObj.chatmail && (
              <li className={stepOption === MARKETING.channels.chatmail ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.chatmail)}>
                <img src={`${getStaticImage('/channels/orange-brand/chatmail-icon.svg')}`} alt='ChatMail' className='icon' />
                ChatMail
                {stepOption === MARKETING.channels.chatmail && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.chatweb && (
              <li className={stepOption === MARKETING.channels.chatweb ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.chatweb)}>
                <img src={`${getStaticImage('/channels/orange-brand/chatweb-icon.svg')}`} alt='ChatWeb' className='icon' />
                {I18n.t('channels_chatweb')}
                {stepOption === MARKETING.channels.chatweb && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.whatsapp && (
              <li
                className={stepOption === MARKETING.channels.whatsapp ? 'active' : ''}
                onClick={() => setStepOption(MARKETING.channels.whatsapp)}
                style={{ display: 'flex' }}
              >
                {/* <i className='fa fa-whatsapp'></i> */}
                <img src={`${getStaticImage('/channels/orange-brand/whatsapp-icon.svg')}`} alt='Whatsapp' className='icon' />
                {I18n.t('channels_twilio_whatsapp')}
                {stepOption === MARKETING.channels.whatsapp && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.whatsapp_whatsapp && (
              <li
                className={stepOption === MARKETING.channels.whatsapp_whatsapp ? 'active' : ''}
                style={{ display: 'flex' }}
                onClick={() => setStepOption(MARKETING.channels.whatsapp_whatsapp)}
              >
                <img src={`${getStaticImage('/channels/orange-brand/whatsapp-icon.svg')}`} alt='Whatsapp Cloud API' className='icon' />
                <p>{I18n.t('channels_whatsapp_whatsapp')}</p>
                {stepOption === MARKETING.channels.whatsapp_whatsapp && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.sms && (
              <li className={stepOption === MARKETING.channels.sms ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.sms)}>
                {/* <i className='fa fa-comments-o'></i>  */}
                <img src={`${getStaticImage('/channels/orange-brand/sms-icon.svg')}`} alt='SMS' className='icon' />
                {I18n.t('channels_sms')}
                {stepOption === MARKETING.channels.sms && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.facebook && (
              <li className={stepOption === MARKETING.channels.facebook ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.facebook)}>
                <img src={`${getStaticImage('/channels/orange-brand/facebook-icon.svg')}`} alt='Facebook Messenger' className='icon' />
                {I18n.t('channels_messenger')}
                {stepOption === MARKETING.channels.facebook && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.instagram && (
              <li className={stepOption === MARKETING.channels.instagram ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.instagram)}>
                <img src={`${getStaticImage('/channels/orange-brand/instagram-icon.svg')}`} alt='Instagram Messenger' className='icon' />
                {I18n.t('channels_instagram')}
                {stepOption === MARKETING.channels.instagram && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.telegram && (
              <li className={stepOption === MARKETING.channels.telegram ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.telegram)}>
                {/* <i className='fa fa-telegram'></i>*/}
                <img src={`${getStaticImage('/channels/orange-brand/telegram-icon.svg')}`} alt='Telegram' className='icon' />
                {I18n.t('channels_telegram')}
                {stepOption === MARKETING.channels.telegram && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.android && (
              <li className={stepOption === MARKETING.channels.android ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.android)}>
                <img src={`${getStaticImage('/channels/orange-brand/android-icon.svg')}`} alt='Android' className='icon' />
                {I18n.t('channels_android')}
                {stepOption === MARKETING.channels.android && <i className='fa fa-chevron-right' />}
              </li>
            )}
            {usersByChannelObj.ios && (
              <li className={stepOption === MARKETING.channels.ios ? 'active' : ''} onClick={() => setStepOption(MARKETING.channels.ios)}>
                <img src={`${getStaticImage('/channels/orange-brand/ios-icon.svg')}`} alt='iOS' className='icon' />
                {I18n.t('channels_wall_ios')}
                {stepOption === MARKETING.channels.ios && <i className='fa fa-chevron-right' />}
              </li>
            )}
          </ul>
        </Col>
        <Col sm={12} xs={9} xl={9}>
          <div className='message-editor-content'>{getCurrentFormStepOption(stepOption)}</div>
        </Col>
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  templates: state.marketing.templates,
  variables: state.marketing.templates.variables,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllTemplates: marketingAct.getAllTemplates,
      getTemplateVariables: marketingAct.getTemplateVariables,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Step3)
